import React from "react";

// TAB gold seal (official uploaded emblem)
export default function TabSeal({ size = 64, className = "" }) {
  return (
    <img
      src="/brand/tab_seal.png"
      alt="The Atmospheric Bureau seal"
      width={size}
      height={size}
      className={`tab-seal-img ${className}`}
      data-testid="tab-seal"
      style={{ width: size, height: size, objectFit: "contain", borderRadius: "50%", filter: "drop-shadow(0 0 10px rgba(212,175,55,0.45))" }}
    />
  );
}
